import { useCallback, useMemo } from 'react';

import { useAuthState } from '@creditornot/wolt-auth/react';

// When checking for user permissions, you should use permissions not roles
export const useUser = () => {
  const { user } = useAuthState();

  const hasRole = useCallback(
    (role: string) => {
      return user?.roles?.some((userRole: string | undefined) => userRole === role) ?? false;
    },
    [user?.roles],
  );

  return useMemo(
    () => ({
      user,
      hasRole,
    }),
    [hasRole, user],
  );
};
